import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import AreasServed from "./components/AreasServed";
import Gallery from "./components/Gallery";
import QuoteForm from "./components/QuoteForm";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import StickyCall from "./components/StickyCall";
import { useReveal } from "./hooks/useReveal";

function HomePage() {
  useReveal();
  return (
    <div data-testid="home-page" className="App">
      <Header />
      <main className="pt-0">
        <Hero />
        <Services />
        <About />
        <AreasServed />
        <Gallery />
        <QuoteForm />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <StickyCall />
    </div>
  );
}

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "#1E1A18",
            border: "1px solid #332C27",
            color: "#F9FAFB",
          },
        }}
      />
    </>
  );
}

export default App;
